module.exports = __webpack_public_path__ + "static/img/patho-edema-medium-ClvhNAPl.9a3a9957.png";